module.exports = __webpack_public_path__ + "img/FrontBodyNumbered.a50701ae.png";